<template>
  <header id="header">
    <h1 id="pageTitle">
      <router-link :to="$i18nRoute({ name: 'Home' })">Fernando Mata</router-link>
    </h1>
    <nav class="links">
      <ul>
        <li v-for="page in menuPages" v-bind:key="page.name">
          <router-link :to="$i18nRoute({ name: page.name })">{{ $t(page.meta.localizedTitleKey) }}</router-link>
        </li>
        <li>
          <a href="../CV_Fernando_Mata.pdf" target="_blank">{{$t("pages.resume")}}</a>
        </li>
      </ul>
    </nav>
    <nav class="main">
      <ul>
        <!-- <li class="search">
          <a class="fa-search" href="#search">Search</a>
          <form id="search" method="get" action="#">
            <input type="text" name="query" placeholder="Search" />
          </form>
        </li>-->
        <li v-if="showMenu">
          <a class="fa-bars" @click="toggleMenu">Menu</a>
          <section id="menu">
          <Slide
          class="sideMenu"
            :burgerIcon="false"
            :isOpen="open"
            right
            @closeMenu="handleCloseMenu"
          >
            <router-link
              class="menu-link"
              v-for="page in menuPages"
              v-bind:key="page.name"
              :to="$i18nRoute({ name: page.name })"
            ><h4>{{ $t(page.meta.localizedTitleKey) }}</h4></router-link>
            <a href="../CV_Fernando_Mata.pdf" target="_blank"><h4>{{$t("pages.resume")}}</h4></a>
          </Slide>
          </section>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { Trans } from "../localization/Translation.js";
import pagesHelper from "../helpers/pagesHelper.js";
import { Slide } from "vue-burger-menu";

export default {
  name: "header",
  computed: {
    mq() {
      return this.$mq;
    },
    menuPages() {
      return pagesHelper.getMenuPages(Trans.currentLanguage, this.$router);
    },
    showMenu() {
      return this.$mq == 'small' || this.$mq == 'verySmall' || this.$mq == 'tiny'
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    toggleMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      this.open = !this.open;
    },
    handleCloseMenu() {
      this.open = false;
    }
  },
  components: {
    Slide
  }
};
</script>

<style>
  #menu .line-style {
	position: absolute;
	height: 20%;
	left: 0;
	right: 0;
  }
  
  #menu .bm-cross {
	background: #bdc3c7;
  }
  #menu .bm-cross-button {
	height: 24px;
	width: 24px;
  }
  #menu .bm-menu {
	height: 100%; /* 100% Full-height */
	width: 0; /* 0 width - change this with JavaScript */
	position: fixed; /* Stay in place */
	z-index: 1000; /* Stay on top */
	top: 0;
	left: 0;
	background-color: rgb(255, 255, 255); /* Black*/
	overflow-x: hidden; /* Disable horizontal scroll */
	padding-top: 60px; /* Place content 60px from the top */
	transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
	border-left: solid 1px rgba(160, 160, 160, 0.3);
  }
  
  #menu .bm-overlay {
	background: rgba(255, 255, 255, 0.3);
  }
  #menu .bm-item-list {
	color: #b8b7ad;
	margin-left: 10%;
	font-size: 20px;
  }
  #menu .bm-item-list > * {
	display: flex;
	text-decoration: none;
	padding: 0.7em;
  }
  #menu .bm-item-list > * > span {
	margin-left: 10px;
	font-weight: 700;
	color: white;
  }
  
  #menu .menu-link {
	border: none;
  }

  #menu .menu-link :hover {
    color: #2ebaae;
  }
</style>

